import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ExternalSettings } from '../../../services/external-settings/external-settings.interface';
import { ExternalSettingsService } from '../../../services/external-settings/external-settings.service';
import { ResponsiveDesignService } from '../../../services/responsive-design/responsive-design.service';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';

/** Result of the enable-notification dialog opened from the dashboard bell. */
export type AppAuthenticatorEnableNotificationChoice = 'enable' | 'dismiss';

export interface AppAuthenticatorEnableNotificationDialogData {
  /** When true, permission was already denied — show settings guidance and Dismiss only. */
  permissionDenied?: boolean;
}

@Component({
  selector: 'app-app-authenticator-enable-notification',
  templateUrl: './app-authenticator-enable-notification.component.html',
  styleUrls: ['./app-authenticator-enable-notification.component.less'],
  standalone: false,
})
export class AppAuthenticatorEnableNotificationComponent implements OnInit {

  UIUtilityService: any = UIUtilityService;
  externalSettings!: ExternalSettings;
  readonly permissionDenied: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AppAuthenticatorEnableNotificationDialogData,
    public dialogRef: MatDialogRef<AppAuthenticatorEnableNotificationComponent, AppAuthenticatorEnableNotificationChoice>,
    private srvES: ExternalSettingsService,
    protected srvRpDesign: ResponsiveDesignService,
  ) {
    this.permissionDenied = !!data?.permissionDenied;
  }

  ngOnInit(): void {
    this.srvES.externalSettings$.subscribe((settings) => {
      this.externalSettings = settings;
    });
  }

  onEnable(): void {
    // Close first; OS permission is requested by AppAuthenticatorService after the overlay is gone.
    this.dialogRef.close('enable');
  }

  onDismiss(): void {
    this.dialogRef.close('dismiss');
  }
}
